import React, { useState, useEffect } from 'react';
import logo from '../assets/images/logo.png';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import '../styles/login.css';

// Services
import LoginService from '../services/loginService';

// Mensajes notificacion
import msgAlerta from '../scripts/alert';

// Modal
import ModalCambioContrasena from '../components/modal/CambioContrasena';

// Material UI
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LockIcon from '@mui/icons-material/Lock';
import IconButton from '@mui/material/IconButton';
import CustomAlerts from '../components/alert/CustomAlerts';
import { NAME_PROJECT } from '../redux/constants/index';

export default function Login() {
  const [userName, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [showPassword, setShowPassword] = useState(false)  
  const [openModal, setOpenModal] = useState(false)
  const [openMessage, setOpenMensaje] = useState(false)
  const [valueAlerts, setValueAlert] = useState({
    title: '',
    message: '',
    severity: ''
  })
  
  const handleClickShowPassword = () => setShowPassword((show) => !show)
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  }

  const SignIn = async () => {
    try {
      setOpenMensaje(false)

      const data = {
        userLogin: userName,
        password: password
      }

      if (!data.userLogin || !data.password) {
        setOpenMensaje(true)
        setValueAlert({
          ...valueAlerts, title: 'Acceso no autorizado', message: (!data.userLogin ? 'Usuario requerido' : 'Contraseña requerida'), severity: 'warning'
        })
        return
      }

      setLoading(true)

      LoginService.LogIn(data)
        .then(async (response) => {
          setTimeout(() => {
            setLoading(false)

            if (!response) {
              setOpenMensaje(true)
              setValueAlert({
                ...valueAlerts, title: 'Error de conexión con API', message: 'Consulte al administrador del sitio.', severity: 'error'
              })
              
              return
            }

            const dataResponse = response.Data

            if (response.Codigo === 1) {
              localStorage.setItem('accessToken', dataResponse.Token)
              localStorage.setItem('user', JSON.stringify(dataResponse))
              
              window.location.href = '/';
            } else {
              if (dataResponse?.IsPwdExpiro) {
                msgAlerta('Error al iniciar sesión', response.Mensaje, 'warning', () => setOpenModal(true), false)
              } else {                
                setOpenMensaje(true)
                setValueAlert({
                  ...valueAlerts, title: 'Error al iniciar sesión', message: response.Mensaje, severity: 'warning'
                })
              }
            }
          }, 1000)
        })
        .catch((error) => {
          setLoading(false)
          msgAlerta('Error ', error, 'error')
        })
    } catch (error) {
      console.error(error)
    }
  }

  const onKeyUpLogin = (e) => {
    try {
      if (e === 'Enter') {
        SignIn()
      }
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    try {
      document.title = `Iniciar Sesión - ${NAME_PROJECT}`;

      if (localStorage.getItem('accessToken')) {
        window.location.href = '/home';
      }
    } catch (error) {
      console.error(error)
    }
  }, [])

  return (
    <div className="App">      
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
         <CircularProgress color="inherit" />
      </Backdrop>

      <section className="App-content-login">
        <ModalCambioContrasena
          setOpenModal={setOpenModal}
          openModal={openModal}
          usuario={userName}
          setLoading={setLoading}
        />

        <div className='col-12 d-flex align-items-center justify-content-center'>
          <div className='shadow rounded border-light p-4 p-lg-5 w-100 fmxw-450 div-login fadeInUp'>
            <div className='text-center text-md-center mb-4 mt-md-0'>
              <h1>Login</h1> {/* <-- TEXTO PARA EL TEST */}
              <img src={logo} className="App-logo-login" alt="logo" />
            </div>
            <FormControl sx={{ my: 3, width: '100%' }} variant="outlined">
              <InputLabel
                htmlFor="outlined-adornment-username"
                className='LabelMui-login'
              >
                Usuario
              </InputLabel>
              <OutlinedInput
                id="outlined-adornment-username"
                type='text'
                className='h-input'
                placeholder='Escribe tu usuario'
                startAdornment={
                  <InputAdornment position="start">
                    <AccountCircleIcon color='error' />
                  </InputAdornment>
                }
                label='Username'
                onChange={(e) => setUsername(e.target.value)}
                onKeyDown={(e) => onKeyUpLogin(e.key)}
              />
            </FormControl>
            <FormControl sx={{ mt: 2, mb: 3, width: '100%' }} variant="outlined">
              <InputLabel
                htmlFor="outlined-adornment-password"
                className='LabelMui-login'
              >
                Contraseña
              </InputLabel>
              <OutlinedInput
                id="outlined-adornment-password"
                type={showPassword ? 'text' : 'password'}
                className='h-input'
                placeholder='Digita la contraseña'
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
                startAdornment={
                  <InputAdornment position="start">
                    <LockIcon color='error' />
                  </InputAdornment>
                }
                label="Password"
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e) => onKeyUpLogin(e.key)}
              />
            </FormControl>
            <div className='d-grid'>
              <button type='button' className='btn btn-danger' onClick={SignIn}>Iniciar sesión</button>

              <CustomAlerts 
                severity={valueAlerts.severity}
                message={valueAlerts.message}
                title={valueAlerts.title}
                open={openMessage}
                setOpen={setOpenMensaje} 
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}